import React from 'react';
import './style.scss';
import { Props } from './model';
import { RandomizedTenantBadgeBackgrounds } from '../../constants';

export function TenantDisplay(props: Props) {
  const [isInvalidImageUrl, setIsInvalidImageUrl] = React.useState<boolean>(
    false
  );

  React.useEffect(() => {
    setIsInvalidImageUrl(false);
  }, [props.tenantImageURL]);

  return (
    <div
      className={`tenant-display-w ${props.renderType} ${
        props.disabled && props.renderType === 'type-1' ? `disable-badge` : ''
      }`}
    >
      {!props.tenantImageURL || isInvalidImageUrl ? (
        <div className="badge-placeholder">
          <img
            src={
              RandomizedTenantBadgeBackgrounds[
                (props.tenantName.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').slice(-1) || '')
              ]
            }
          />
          <div>{props.tenantName[0]}</div>
        </div>
      ) : (
        <img
          src={props.tenantImageURL}
          onError={() => setIsInvalidImageUrl(true)}
          onLoad={() => setIsInvalidImageUrl(false)}
        />
      )}
      {props.renderType === 'type-3' ? null : (
        <div className="tenant-name">{props.tenantName}</div>
      )}
      {props.disabled ? <div className="tenant-disabled">Disabled</div> : null}
    </div>
  );
}
